const SALARY_CONTEXT_COLLAPSED_KEY = 'job-detail-salary-context-collapsed';
const COMPANY_INFO_COLLAPSED_KEY = 'job-detail-company-info-collapsed';

function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

function readBooleanPreference(key: string, fallback: boolean): boolean {
  if (!isBrowser()) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return fallback;
  } catch {
    return fallback;
  }
}

function writeBooleanPreference(key: string, value: boolean): void {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(key, value ? 'true' : 'false');
  } catch {
    // Ignore storage write errors (privacy mode/quota)
  }
}

export function readSalaryContextCollapsedPreference(): boolean {
  return readBooleanPreference(SALARY_CONTEXT_COLLAPSED_KEY, true);
}

export function writeSalaryContextCollapsedPreference(collapsed: boolean): void {
  writeBooleanPreference(SALARY_CONTEXT_COLLAPSED_KEY, collapsed);
}

export function readCompanyInfoCollapsedPreference(): boolean {
  return readBooleanPreference(COMPANY_INFO_COLLAPSED_KEY, true);
}

export function writeCompanyInfoCollapsedPreference(collapsed: boolean): void {
  writeBooleanPreference(COMPANY_INFO_COLLAPSED_KEY, collapsed);
}
